import { render, staticRenderFns } from "./VPRPublicationsList.vue?vue&type=template&id=b2032892&"
import script from "./VPRPublicationsList.vue?vue&type=script&lang=js&"
export * from "./VPRPublicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports